import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Typography, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import SearchComponent from './Search';
import { useAuth } from '../contexts/AuthContext';

interface TopNavProps {
  userData: any;
}

const AppBarWrapper = styled(AppBar)({
  boxShadow: 'none !important',
  height: '4rem',
});

const ToolbarWrapper = styled(Toolbar)({
  '@media (max-width: 600px)': {
    margin: '0rem 2rem',
    padding: 0,
  },
});

const DrawerBoxLogo = styled(Typography)({
  margin: '2rem 0rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#203064',
});

const Icon = styled('img')({
  width: '240px',
  height: '60px',
  paddingRight: '5px',
  background: '#203064',

  '@media (max-width: 500px)': {
    width: '11rem',
    height: '2.8rem',
  },

  '@media (max-width: 400px)': {
    width: '9rem',
    height: '2.5rem',
  },
});

const TopNav: React.FC<TopNavProps> = ({ userData }) => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const { logout, user } = useAuth();

  const searchChangeHandler = (event: any) => {
    setSearchValue(event.target.value);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = async () => {
    await logout();
    setLogoutDialogOpen(false);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  return (
    <div style={{ width: '100%' }}>
      <AppBarWrapper
        position='fixed'
        sx={{ background: '#203064', zIndex: 1 }}
      >
        <ToolbarWrapper
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '0rem 2rem',
          }}
        >
          <DrawerBoxLogo variant='h6'>
            <Icon src='/logo.png' alt='moitele' />
          </DrawerBoxLogo>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant="body2" sx={{ color: 'white' }}>
              Welcome, {user?.username}
            </Typography>
            <Button 
              variant="outlined" 
              color="inherit" 
              onClick={handleLogoutClick}
              sx={{ 
                borderColor: 'rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': {
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              Logout
            </Button>
            <SearchComponent searchChangeHandler={searchChangeHandler} />
          </Box>
        </ToolbarWrapper>
      </AppBarWrapper>
      <main style={{ flexGrow: 1 }}>
        <Toolbar />
        <Outlet context={[searchValue, userData]} />
      </main>
      
      <Dialog 
        open={logoutDialogOpen} 
        onClose={handleLogoutCancel}
        PaperProps={{
          sx: {
            backgroundColor: '#203064',
            color: 'white',
            minWidth: '300px'
          }
        }}
      >
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          Are you sure you want to logout?
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleLogoutCancel} 
            color="inherit"
            sx={{ color: 'white' }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleLogoutConfirm} 
            variant="contained"
            sx={{ 
              backgroundColor: '#ff5252',
              '&:hover': {
                backgroundColor: '#ff6b6b'
              }
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TopNav;
